const config = {
  url: process.env.REACT_APP_API_URL || '',
  staticUrl: `${process.env.REACT_APP_API_URL}/static/` || '',
  thumbUrl: `${process.env.REACT_APP_API_URL}/thumb/` || '',
}
export default config
